module.exports = __webpack_public_path__ + "img/fundermax-obra-2-1.b5949adb.jpg";